<template>
  <div class="password-reset">
    <div class="password-reset__wrapper">
      <AppHeading tag="h2" :text="$t('pages.login.enter_new_password')" class="form__title" />
      <!-- subtitle -->
      <!-- <AppHeading tag="span" :text="$t('pages.login.enter_new_password')" class="form__subtitle" /> -->
      <!-- FORM -->
      <AppForm @submit.prevent="resetPassword" class="form__form">
        <!-- password -->
        <AppInput
          class="form__input"
          v-model="$v.userInfo.new_password.$model"
          autocomplete="off"
          :floating-label="false"
          :label="$t('forms.placeholders.new_password')"
          :disabled="sendingData"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'fal fa-eye' : 'fal fa-eye-slash'"
          @click:append="showPassword = !showPassword"
        />
        <div v-if="$v.userInfo.new_password.$dirty" class="form__errors-messages">
          <p class="form__errors-message">
            <AppIcon :icon="validationIcon('new_password', 'minLength')" />
            {{ $t('forms.error.minimum_characters', { value: 8 }) }}
          </p>
          <p class="form__errors-message">
            <AppIcon :icon="validationIcon('new_password', 'alphaNum')" />
            {{ $t('forms.error.alphaNum') }}
          </p>
        </div>
        <!-- password cofirmed -->
        <AppInput
          class="form__input"
          v-model="$v.userInfo.new_password_confirmed.$model"
          autocomplete="off"
          :floating-label="false"
          :label="$t('forms.placeholders.confirm_new_password')"
          :disabled="sendingData"
          :type="showConfirmation ? 'text' : 'password'"
          :append-icon="showConfirmation ? 'fal fa-eye' : 'fal fa-eye-slash'"
          @click:append="showConfirmation = !showConfirmation"
        />

        <div v-if="$v.userInfo.new_password_confirmed.$dirty" class="form__errors-messages">
          <p class="form__errors-message">
            <AppIcon :icon="validationIcon('new_password_confirmed', 'sameAs')" />
            {{ $t('forms.error.passwords_must_match') }}
          </p>
        </div>
        <!-- back to login -->
        <AppRouterLink
          class="form__back-link"
          exact
          :to="{ name: 'login' }"
          :text="$t('forms.label.back_login')"
        />
        <!-- submit -->
        <SubmitButtonMagenta
          type="submit"
          :loading="sendingData"
          :disabled="$v.userInfo.$invalid"
          spinner-color="#fff"
        >
          {{ $t('ui.buttons.password_reset') }}
        </SubmitButtonMagenta>
      </AppForm>
    </div>
  </div>
</template>

<script>
// Utils
import { checkApiResponse } from 'Utils'
import { required, sameAs } from 'vuelidate/lib/validators'
import { Notification } from 'Utils/Classes/Notification'
import LoginResetFormMixin from 'Mixins/Forms/loginResetForms'

export default {
  name: 'PasswordResetForm',

  props: {
    userId: {
      type: String,
      required: true,
    },

    token: {
      type: String,
      required: true,
    },
  },

  mixins: [LoginResetFormMixin],

  data() {
    return {
      showPassword: false,
      showConfirmation: false,
      userInfo: {
        new_password: null,
        new_password_confirmed: null,
      },
    }
  },

  validations: {
    userInfo: {
      new_password: {
        required,
        minLength: (new_password) => new_password?.length >= 8,
        alphaNum: (new_password) => {
          return (
            /[a-z]/.test(new_password) /*&& /[A-Z]/.test(new_password)*/ &&
            /[0-9]/.test(new_password)
          )
        },
      },

      new_password_confirmed: {
        required,
        sameAs: sameAs('new_password'),
      },
    },
  },

  methods: {
    resetData() {
      this.userInfo = {
        new_password: null,
        new_password_confirmed: null,
      }
    },

    async resetPassword() {
      if (this.$v.userInfo.$invalid) return

      const notification = new Notification()
      this.toggleSendingData()

      const newPasswordData = {
        uid: this.userId,
        token: this.token,
        new_password1: this.userInfo.new_password,
        new_password2: this.userInfo.new_password_confirmed,
      }

      const newPassword = await this.$store.dispatch('user/resetUserPassword', newPasswordData)

      if (!checkApiResponse(newPassword)) {
        // could be bad token, uid, or form fileds.
        notification.timeout = 6000
        notification.message = this.$i18n.t('ui.notifications.password_reset.error')
        notification.dispatch()
        this.toggleSendingData()
      } else {
        notification.type = 'success'
        notification.timeout = 4000
        notification.message = this.$i18n.t('ui.notifications.password_reset.success')
        // To login form
        this.$router.push({
          name: 'login',
          params: { pw_reset_userId: undefined, pw_reset_token: undefined },
        })
        notification.dispatch()
        this.resetData()
      }
    },
  },

  computed: {
    hasData() {
      return this.userInfo.new_password && this.userInfo.new_password_confirmed
    },

    showClass() {
      return this.passwordsDontMatch && 'show'
    },

    passwordsDontMatch() {
      return this.userInfo.new_password !== this.userInfo.new_password_confirmed
    },

    validationIcon() {
      return (validationType, property) => {
        return this.$v.userInfo[validationType][property] ? 'far fa-check' : 'far fa-times'
      }
    },
  },
}
</script>

<style scoped src="@/assets/css/shared-styles/login-forms.css"></style>
<style scoped>
.form__title {
  margin-bottom: 60px;
}
</style>
